import type { Table } from '@tanstack/react-table';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';
import { useMemo } from 'react';
import { Button } from 'shared/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'shared/ui/select';
import * as m from '@paraglide/messages';
interface DataTablePaginationProps<TData> {
  table: Table<TData>;
  rowsPerPage: number[];
  variant?: 'default' | 'list';
}
export function DataTablePagination<TData>({
  table,
  rowsPerPage,
  variant = 'default'
}: DataTablePaginationProps<TData>) {
  const isDefault = useMemo(() => variant === 'default', [variant]);
  return <div className="flex items-center justify-between px-2" data-sentry-component="DataTablePagination" data-sentry-source-file="data-table-pagination.tsx">
      <div className="flex-1 text-sm text-muted-foreground">
        {/* {table.getFilteredSelectedRowModel().rows.length} of{' '} */}
        {/* {table.getFilteredRowModel().rows.length} row(s) selected. */}
      </div>
      <div className="flex items-center space-x-6 lg:space-x-8">
        <div className="flex items-center space-x-2">
          <p className="text-body3 font-medium">
            {m.data_table_pagination_rpp()}
          </p>
          <Select value={`${table.getState().pagination.pageSize}`} onValueChange={value => {
          table.setPageSize(Number(value));
        }} data-sentry-element="Select" data-sentry-source-file="data-table-pagination.tsx">
            <SelectTrigger className="h-6 w-[70px]" data-sentry-element="SelectTrigger" data-sentry-source-file="data-table-pagination.tsx">
              <SelectValue placeholder={table.getState().pagination.pageSize} data-sentry-element="SelectValue" data-sentry-source-file="data-table-pagination.tsx" />
            </SelectTrigger>
            <SelectContent side="top" data-sentry-element="SelectContent" data-sentry-source-file="data-table-pagination.tsx">
              {rowsPerPage.map(pageSize => <SelectItem key={pageSize} value={`${pageSize}`}>
                  {pageSize}
                </SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div className="flex w-[100px] items-center justify-center text-body3 font-medium">
          {m.data_table_pagination_page()}{' '}
          {table.getState().pagination.pageIndex + 1} из {table.getPageCount()}
        </div>
        <div className="flex items-center space-x-2">
          {isDefault && <Button variant="outline" className="hidden size-6 p-0 lg:flex" onClick={() => table.setPageIndex(0)} disabled={!table.getCanPreviousPage()}>
              <span className="sr-only">Go to first page</span>
              <ChevronsLeft className="size-4" />
            </Button>}
          <Button variant="outline" className="size-6 p-0" onClick={() => table.previousPage()} disabled={!table.getCanPreviousPage()} data-sentry-element="Button" data-sentry-source-file="data-table-pagination.tsx">
            <span className="sr-only">Go to previous page</span>
            <ChevronLeft className="size-4" data-sentry-element="ChevronLeft" data-sentry-source-file="data-table-pagination.tsx" />
          </Button>
          <Button variant="outline" className="size-6 p-0" onClick={() => table.nextPage()} disabled={!table.getCanNextPage()} data-sentry-element="Button" data-sentry-source-file="data-table-pagination.tsx">
            <span className="sr-only">Go to next page</span>
            <ChevronRight className="size-4" data-sentry-element="ChevronRight" data-sentry-source-file="data-table-pagination.tsx" />
          </Button>
          {isDefault && <Button variant="outline" className="hidden size-6 p-0 lg:flex" onClick={() => table.setPageIndex(table.getPageCount() - 1)} disabled={!table.getCanNextPage() || table.getPageCount() === -1}>
              <span className="sr-only">Go to last page</span>
              <ChevronsRight className="size-4" />
            </Button>}
        </div>
      </div>
    </div>;
}